import React, { Component } from 'react';
import { Pivot, PivotItem } from 'office-ui-fabric-react/lib/Pivot';
import { MyContext } from '../../context';
import Profiles from './Profiles';
import ProfileRules from './ProfileRules';

class RecordingProfiles extends Component {

    render() {
        return (
            <MyContext.Consumer>
                {(context) => (
                    <>
                        <Pivot>
                            <PivotItem headerText={context.getTranslation("configuration", "profiles")}>
                                <>
                                    <Profiles profileData={this.props.profileData} ruleData={this.props.ruleData} profileRulesData={this.props.profileRulesData} apol={this.props.apol} authorization={this.props.authorization} userRules={this.props.userRules} accessProfiles={this.props.accessProfiles} dataUsers={this.props.dataUsers} dataGroups={this.props.dataGroups} tenantData={this.props.tenantData} />
                                </>
                            </PivotItem>
                            <PivotItem headerText={context.getTranslation("configuration", "profileRules")}>
                                <>
                                    <ProfileRules profileRulesData={this.props.profileRulesData} apol={this.props.apol} authorization={this.props.authorization} userRules={this.props.userRules} accessProfiles={this.props.accessProfiles} tenantData={this.props.tenantData} />
                                </>
                            </PivotItem>
                        </Pivot>
                    </>
                )}
            </MyContext.Consumer>
        );
    }
}

export default RecordingProfiles;
